export default "__VITE_PUBLIC_ASSET__9bcdcc9f__"